exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".input-group[_v-31d32128]{width:100%}.input-group button[_v-31d32128]{padding:5px 12px}.custom-checkbox label[_v-31d32128]{font-size:12px;color:#000;font-family:Open Sans}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-31d32128&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Admin/Admin-product-general.vue
// module id = 416
// module chunks = 0